import api from "./axiosInstance";

import { baseURL, createHeaders } from "./constants";

const keysPair = async (params) => {
  const { id } = params;
  return api.get(`${baseURL}/company-api-keys?populate=*&filters[company][id]=${id}`, {
    headers: createHeaders()
  });
};

const deleteKeysPair = async (id) => {
  return api.delete(`${baseURL}/company-api-keys/${id}`, {
    headers: createHeaders()
  });
};

const getKeyPairById = async (id) => {
  return api.get(`${baseURL}/company-api-keys/${id}?populate=*`, {
    headers: createHeaders()
  });
};

const editKeyPair = async (id, data) => {
  return api.put(`${baseURL}/company-api-keys/${id}`, data, {
    headers: createHeaders()
  });
};

const regenerateKeys = async (id) => {
  return api.post(`${baseURL}/regenerate-keys`, { apiKeyId: id }, {
    headers: createHeaders()
  });
};

export { keysPair, deleteKeysPair, editKeyPair, getKeyPairById, regenerateKeys };